// @ts-nocheck
// Exact live version restored from the production sourcemap (portal.rebels.io, 2026-10-23).
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from 'react/jsx-runtime';
import { Box, Dialog, Grid, IconButton, Typography } from '@mui/material';
import { CloseCircle, Eye } from 'iconsax-react';
import React, { useEffect, useState } from 'react';
import { CustomChip } from '../../../../components/common/chip/Chip';
import { WidgetHeader } from '../../../../components/common/header/widgetHeader/WidgetHeader';
import { QInput } from '../../../../components/common/inputs/QInput';
import { black500, black400 } from '../../../../constants/color';
import { useAppDispatch, useAppSelector } from '@application/store/useStore';
import { HoursStatus } from '@application/common/enums/hours-status';
import { PrimaryGrid } from '@ui/components/common/grid/PrimaryGrid';
import { getHoursByTimeSheetIds } from '@application/features/HoursRegistration/hoursRegistrationThunk';
import { ClientContractStatus } from '@application/common/enums/client-contract-status';
import { formatDisplayDate } from '../hours-dates';
// const theme = useTheme();
export const AcptedTimSheet = ({ open, handleClose }) => {
    const { timeSheetWithClientInfo } = useAppSelector((state) => state.timeSheet);
    const [hourAndTimeSheetDetail, setHourDetailAndTimeSheetDetail] = useState(null);
    const [totalNoOfHours, settotalNoOfHours] = useState(0);
    const [step, setStep] = useState(1);
    const [clientName, setClientName] = useState('');
    const [monthYearLabel, setMonthYearLabel] = useState('');
    const dispatch = useAppDispatch();
    useEffect(() => {
        if (!open) {
            setStep(1);
            setHourDetailAndTimeSheetDetail(null);
            settotalNoOfHours(0);
        }
    }, [open]);
    const getTitle = (status) => {
        switch (status) {
            case 'Pending':
                return 'Pending Timesheets';
            case 'Approved':
                return 'Approved Timesheets';
            default:
                return 'Timesheets';
        }
    };
    const columns = [
        {
            field: 'monthName',
            headerName: 'Timesheets',
            flex: 2
        },
        {
            field: 'allClientNames',
            headerName: 'Registration',
            flex: 2
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 2,
            headerAlign: 'center',
            align: 'center',
            renderCell: (params) => _jsx(CustomChip, { value: params.value })
        },
        {
            field: 'action',
            headerName: 'View',
            flex: 0.5,
            renderCell: (params) => _jsx(IconButton, {
                onClick: () => {
                    const timeSheetIds = params.row.id;
                    setClientName(params.row.allClientNames);
                    setMonthYearLabel(params.row.monthName);
                    dispatch(getHoursByTimeSheetIds(timeSheetIds))
                        .unwrap()
                        .then((response) => {
                        setHourDetailAndTimeSheetDetail(response);
                        settotalNoOfHours(sumFilteredHours(response));
                        setStep(2); // Move to the next step
                    });
                },
                children: _jsx(Eye, {})
            })
        }
    ];
    const sumFilteredHours = (timeSheetDetails) => {
        return timeSheetDetails.reduce((totalHours, timeSheet) => {
            const weekSum = timeSheet.weeklyHourRegistrations.reduce((weekTotal, weeklyRegistration) => {
                const validHours = weeklyRegistration.hourRegistrations
                    .filter((hourEntry) => hourEntry.systemCode !== 'NO_EXPORT')
                    .reduce((hourTotal, hourEntry) => hourTotal + hourEntry.noOfHours, 0);
                return weekTotal + validHours;
            }, 0);
            return totalHours + weekSum;
        }, 0);
    };
    const rows = timeSheetWithClientInfo?.timeSheetWithClientInfo.map((data, index) => {
        const contextDisplay = data.contextName || data.allClientNames;
        const clientDisplay = data.assignmentStatus == ClientContractStatus.Expired ? `${contextDisplay} (Expired ${data.contractEndDate})` : contextDisplay;
        const allClientNames = data.projectTaskName ? `${clientDisplay} - ${data.projectTaskName}` : clientDisplay;
        return {
            id: data.timeSheetIds,
            monthName: data.monthName,
            allClientNames,
            status: `${HoursStatus[data.timeSheetStatus]}`
        };
    });
    const renderInputRow = (weeklyHourDetail) => _jsx(_Fragment, {
        children: _jsxs(Grid, {
            container: true,
            columnSpacing: 2,
            rowSpacing: 2,
            mt: '0.2px',
            pb: '20px',
            children: [
                _jsx(Grid, {
                    item: true,
                    xs: 3,
                    children: _jsx(Typography, { variant: 'subtitle2', color: black500, children: 'Date' })
                }),
                _jsx(Grid, {
                    item: true,
                    xs: 6,
                    children: _jsx(Typography, { variant: 'subtitle2', color: black500, children: 'Registration' })
                }),
                _jsx(Grid, {
                    item: true,
                    xs: 3,
                    children: _jsx(Typography, { variant: 'subtitle2', color: black500, children: 'Register' })
                }),
                weeklyHourDetail.weeklyHourRegistrations.map((weeklyDetails, index) => _jsx(React.Fragment, {
                    children: weeklyDetails.hourRegistrations.map((hourDetail, hourIndex) => _jsxs(React.Fragment, {
                        children: [
                            _jsx(Grid, {
                                item: true,
                                md: 3,
                                xs: 3,
                                lg: 3,
                                display: 'flex',
                                alignItems: 'center',
                                children: _jsx(Typography, {
                                    variant: 'subtitle2',
                                    color: black400,
                                    fontSize: { xs: '11px', sm: '14px' },
                                    children: formatDisplayDate(hourDetail.date)
                                })
                            }),
                            _jsx(Grid, {
                                item: true,
                                md: 6,
                                xs: 6,
                                lg: 6,
                                children: _jsx(QInput, {
                                    fillBackground: true,
                                    placeholder: 'Registration',
                                    disabled: true,
                                    value: hourDetail.displayName || hourDetail.clientName
                                })
                            }),
                            _jsx(Grid, {
                                item: true,
                                md: 3,
                                xs: 3,
                                lg: 3,
                                children: _jsx(QInput, {
                                    disabled: true,
                                    fillBackground: true,
                                    placeholder: '0',
                                    value: hourDetail.noOfHours
                                })
                            })
                        ]
                    }, hourIndex))
                }, index))
            ]
        })
    });
    const status = timeSheetWithClientInfo?.timeSheetWithClientInfo?.[0]?.timeSheetStatus ?? HoursStatus.Pending;
    return _jsx(Dialog, {
        open: open,
        onClose: handleClose,
        maxWidth: false,
        BackdropProps: {
            sx: {
                backdropFilter: 'blur(3px)',
                backgroundColor: 'rgba(74, 74, 74, 0.25)'
            }
        },
        PaperProps: {
            sx: {
                width: '620px',
                maxHeight: '90vh',
                overflow: 'hidden'
            }
        },
        children: step === 1
            ? _jsxs(Box, {
                children: [
                    _jsx(Box, {
                        sx: {
                            position: 'sticky',
                            top: 0,
                            zIndex: 2,
                            backgroundColor: 'white'
                        },
                        children: _jsxs(WidgetHeader, {
                            background: 'white',
                            children: [
                                _jsx(Typography, {
                                    fontSize: '20px',
                                    color: 'black',
                                    sx: {
                                        whiteSpace: 'normal',
                                        wordBreak: 'break-word'
                                    },
                                    children: getTitle(HoursStatus[status])
                                }),
                                _jsx(IconButton, {
                                    onClick: handleClose,
                                    sx: { padding: { xs: '0px', md: '8px' } },
                                    children: _jsx(CloseCircle, { style: { color: 'black' } })
                                })
                            ]
                        })
                    }),
                    _jsx(Box, {
                        sx: {
                            padding: { md: '25px' },
                            overflowX: 'auto',
                            overflowY: 'auto',
                            maxHeight: 'calc(90vh - 10px)',
                            minWidth: '310px'
                        },
                        children: _jsx(Box, {
                            sx: { minWidth: '310px' },
                            children: _jsx(PrimaryGrid, { columns: columns, rows: rows })
                        })
                    })
                ]
            })
            : _jsxs(Box, {
                children: [
                    _jsx(Box, {
                        sx: {
                            position: 'sticky',
                            top: 0,
                            zIndex: 2,
                            backgroundColor: 'white'
                        },
                        children: _jsxs(WidgetHeader, {
                            background: 'white',
                            children: [
                                _jsxs(Typography, {
                                    fontSize: '20px',
                                    color: 'black',
                                    sx: {
                                        whiteSpace: 'normal',
                                        wordBreak: 'break-word'
                                    },
                                    children: [clientName, ' - ', monthYearLabel]
                                }),
                                _jsx(IconButton, {
                                    onClick: handleClose,
                                    sx: { padding: { xs: '0px', md: '8px' } },
                                    children: _jsx(CloseCircle, { style: { color: 'black' } })
                                })
                            ]
                        })
                    }),
                    _jsx(Box, {
                        sx: {
                            padding: { xs: '16px', md: '25px' },
                            overflowX: 'auto',
                            overflowY: 'auto',
                            maxHeight: 'calc(90vh - 10px)',
                            minWidth: '310px'
                        },
                        children: _jsx(Box, {
                            sx: { minWidth: '310px' },
                            children: _jsx(Box, {
                                position: 'relative',
                                children: _jsx(Box, {
                                    height: 500,
                                    pt: 2,
                                    pb: 5,
                                    children: _jsxs(Grid, {
                                        container: true,
                                        spacing: 3,
                                        pb: 2,
                                        children: [
                                            hourAndTimeSheetDetail &&
                                                hourAndTimeSheetDetail.map((record) => _jsx(Grid, {
                                                    item: true,
                                                    xs: 12,
                                                    children: _jsx(_Fragment, { children: renderInputRow(record) })
                                                })),
                                            _jsx(Grid, {
                                                item: true,
                                                md: 12,
                                                pt: 2,
                                                children: _jsxs(Box, {
                                                    sx: {
                                                        display: 'flex',
                                                        gap: { xs: 1, md: 2 },
                                                        justifyContent: 'flex-end',
                                                        alignItems: 'center',
                                                        width: '100%'
                                                    },
                                                    children: [
                                                        _jsx(Typography, {
                                                            variant: 'subtitle2',
                                                            color: 'initial',
                                                            children: 'Total hours'
                                                        }),
                                                        _jsx(Box, {
                                                            width: { xs: 200, md: 240 },
                                                            children: _jsx(QInput, { value: totalNoOfHours, disabled: true })
                                                        })
                                                    ]
                                                })
                                            })
                                        ]
                                    })
                                })
                            })
                        })
                    })
                ]
            })
    });
};
